import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

//Страницы
import Sidebar from "./Components/Sidebar/Sidebar";
import PageContent from "./Components/PageLayout/PageContent";
import PageLayout from "./Components/PageLayout/PageLayout";
import HomePage from "./Pages/HomePage/HomePage";
import BoardPage from "./Pages/BoardPage/BoardPage";
import TaskDetail from "./Pages/Task/TaskDetail";
import TicketChatsPage from "./Pages/TicketChatsPage/TicketChatsPage";
import ShiftsPage from "./Pages/ShiftsPage/ShiftsPage";
import UsersPage from "./Pages/UsersPage/UsersPage";

import ProtectedRoute from "./Components/ProtectedRoute";
import { ANALYTICS_ALLOWED_ROLES, IT_TS_ALLOWED_ROLES, USER_MANAGEMENT_ALLOWED_ROLES } from "./services/clientAuth";
import TemplateManager from "./Pages/TemplateManager/TemplateManager";
import TeamManager from "./Pages/TeamManager/TeamManager";
import SuncSpravochnik from "./Pages/SuncSpavochnik/SuncSpravochnik";
import ItBacklog from "./Pages/ItBacklog/ItBacklog";

// ВАЖНО: путь импорта приведи к одному стилю папок (у тебя уже смешано Pages/pages)
import ItBacklogPublic from "./Pages/ItBacklog/ItBacklogPublic";
import ProfilePage from "./Pages/ProfilePage/ProfilePage";
import AnalyticsPage from "./Pages/Analytics/AnalyticsPage";
import ChatsPage from "./Pages/ChatsPage/ChatsPage";
import NotificationsPage from "./Pages/NotificationsPage/NotificationsPage";
import SupportV2App from "./V2/V2App";
import ManagerWorkspace from "./Manager/ManagerWorkspace";

// Fix for mobile 100vh (iOS/Android address bar)
function setVhVar() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
}
setVhVar();
window.addEventListener("resize", setVhVar);
window.addEventListener("orientationchange", setVhVar);

function applyInitialTheme() {
    let initialTheme = "light";
    try {
        const storedTheme = localStorage.getItem("theme");
        if (storedTheme === "dark" || storedTheme === "light") {
            initialTheme = storedTheme;
        }
    } catch {
        // ignore
    }
    document.body.setAttribute("data-theme", initialTheme);
}

applyInitialTheme();

const privateRoutes = [
    {
        path: "/manager/*",
        element: <ProtectedRoute allowedRoles={['ROLE_MANAGER']}><ManagerWorkspace/></ProtectedRoute>,
    },
    {
        path: "/v2/*",
        element: (
            <ProtectedRoute>
                <SupportV2App />
            </ProtectedRoute>
        ),
    },
    {
        path: "/",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute>
                        <BoardPage />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/ItBacklog",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute>
                        <ItBacklog />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/board",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute>
                        <BoardPage />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/task/:taskId",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute>
                        <TaskDetail />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/it-ts",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute allowedRoles={IT_TS_ALLOWED_ROLES}>
                        <TicketChatsPage />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/shifts",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute allowedRoles={IT_TS_ALLOWED_ROLES}>
                        <ShiftsPage />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/users",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute allowedRoles={USER_MANAGEMENT_ALLOWED_ROLES}>
                        <UsersPage />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/templates",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute>
                        <TemplateManager />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/team",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute>
                        <TeamManager />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/SuncSpravochnik",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute>
                        <SuncSpravochnik />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/analytics",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute allowedRoles={ANALYTICS_ALLOWED_ROLES}>
                        <AnalyticsPage />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/profile",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute>
                    <ProfilePage />
                </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/chats",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute>
                        <ChatsPage />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/chats/:chatId",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute>
                        <ChatsPage />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
    {
        path: "/notifications",
        element: (
            <PageLayout>
                <Sidebar />
                <PageContent>
                    <ProtectedRoute>
                        <NotificationsPage />
                    </ProtectedRoute>
                </PageContent>
            </PageLayout>
        ),
    },
];

// Публичные маршруты (без Sidebar и без ProtectedRoute)
const publicRoutes = [
    {
        path: "/backlog/public",
        element: (
            <PageLayout>
                <PageContent>
                    <ItBacklogPublic />
                </PageContent>
            </PageLayout>
        ),
    },
];

const router = createBrowserRouter([...publicRoutes, ...privateRoutes]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);
